import * as React from 'react';
import { toast } from 'react-toastify';
import DriverTabData from './DriverTab';
import DriverJobsListData from './DriverJobsList';
import DriverJobsDepartOfficeData from './DriverJobsDepartOffice';
import DriverJobsSiteArrivalData from './DriverJobsSiteArrival';
import DriverJobsSiteArrivalSwmsData from './DriverJobsSiteArrivalSwms';
import DriverJobsSiteDepartureData from './DriverJobsSiteDeparture';
import DriverJobsSiteDepartureSkipData from './DriverJobsSiteDepartureSkip';
import DriverJobsSiteDeparturePartData from './DriverJobsSiteDeparturePart';
import DriverJobsSiteDeparturePartItemsData from './DriverJobsSiteDeparturePartItems';
import DriverJobsSiteDeparturePartQuestionsData from './DriverJobsSiteDeparturePartQuestions';
//import DriverJobsSiteDepartureVoidQuestionsData from './DriverJobsSiteDepartureVoidQuestions';
import DriverJobsSiteDepartureCompleteData from './DriverJobsSiteDepartureComplete';
import DriverJobsSiteDepartureCompleteQuestionsData from './DriverJobsSiteDepartureCompleteQuestions';
import type { VoidGearList } from './models/JobScaffoldInterfaces';
import * as UtilsGoogleMaps from './UtilsGoogleMaps';
import { useState } from 'react';
import type { GenericList } from './models/JobSharedInterfaces';
import { GetQuery, PostFormDataQuery, PostQuery } from './Shared';
import type { ArrivalCheck, CompletionCheck, DepartureCheck, DriverJob, ItemPart, PartCompleteJob, PlanChanges, SwmsItem } from './models/DriverJobInterfaces';
import { useNavigate } from 'react-router-dom';
import type { GoogleAddressItem } from './models/JobScheduleInterfaces';

interface TruckJobList {
    truckId: number;
    estimatedSiteTimeFormatted: string;
    actualSiteTimeFormatted: string;
    estimatedTravelTimeFormatted: string;
    actualTravelTimeFormatted: string;
    truckCheckComplete: boolean;
    truckToolCheckComplete: boolean;
    truckFinalToolCheckComplete: boolean;
    allJobsComplete: boolean;
    hasDepartedOffice: boolean;
    hasArrivedOffice: boolean;
    hadLunch: boolean;
    truckNotes: string;
    jobs: DriverJob[];
}

const DriverJobsData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [truckOptions, setTruckOptions] = useState<GenericList[]>([]);
    const [truckJobList, setTruckJobList] = useState<TruckJobList[]>([]);
    const [scheduleTypes, setScheduleTypes] = useState<GenericList[]>([]);
    const [showDepartOffice, setShowDepartOffice] = useState(false);
    const [showArriveSite, setShowArriveSite] = useState(false);
    const [showArriveSiteSwms, setShowArriveSiteSwms] = useState(false);
    const [showDepartSite, setShowDepartSite] = useState(false);
    const [showSkipJob, setShowSkipJob] = useState(false);
    const [skipJobNotes, setSkipJobNotes] = useState("");
    const [showPartComplete, setShowPartComplete] = useState(false);
    const [showPartItems, setShowPartItems] = useState(false);
    const [showPartQuestions, setShowPartQuestions] = useState(false);
    const [isPickup, setIsPickup] = useState(false);
    const [showComplete, setShowComplete] = useState(false);
    const [showCompleteQuestions, setShowCompleteQuestions] = useState(false);
    //const [showVoidQuestions, setShowVoidQuestions] = useState(false);
    const [partCompleteJob, setPartCompleteJob] = useState<PartCompleteJob>({
        planChanges: {
            planChanges: -1,
            plan: new File([""], "filename"),
            planComments: "",
            notes: ""
        },
        jobItems: [],
        notes: ""
    });
    const [completeJob, setCompleteJob] = useState<PlanChanges>({
        planChanges: -1,
        plan: new File([""], "filename"),
        planComments: "",
        notes: ""
    });
    const [completionCheck, setCompletionCheck] = useState<CompletionCheck>({
        swmsSiteContact: -1,
        scaffoldSquare: -1,
        scaffoldGaps: -1,
        accessPointsInstalled: -1,
        scaffoldSupported: -1,
        safetySigns: -1,
        handrailsChecked: -1,
        gapsChecked: -1,
        fittingsSecure: -1,
        siteChecked: -1,
        rubbishInBin: -1,
        siteSecured: -1,
        scaffoldSafeCondition: -1,
        scaffoldDamage: -1,
        missingEquipment: -1,
        scaffoldCertificateSigned: -1,
        scaffoldTicketPhoto: -1,
        scaffoldPhotosComplete: -1,
        scaffoldTicketSignedById: -1,
        notes: ""
    });
    const [jobType, setJobType] = useState(0);
    const [isKwikstage, setIsKwikstage] = useState(false);
    const [team, setTeam] = useState<GenericList[]>([]);
    const [truckIndex, setTruckIndex] = useState(-1);
    const [jobIndex, setJobIndex] = useState(-1);
    const [isAssistJob, setIsAssistJob] = useState(false);
    //const [isVoidJob, setIsVoidJob] = useState(false);
    const [isManualJob, setIsManualJob] = useState(false);
    const [departureCheck, setDepartureCheck] = useState<DepartureCheck>({
        id: 0,
        gearCheck: -1,
        teamMemberPpe: -1
    });
    const [arrivalCheck, setArrivalCheck] = useState<ArrivalCheck>({
        id: 0,
        hazardsRemoved: -1,
        workAreasChecked: -1,
        layoutPlanMaterialsAvailable: -1,
        siteDamage: -1,
        siteDamageNotes: "",
        siteSwmsChecked: -1
    });
    const [voidGearList, setVoidGearList] = useState<VoidGearList[]>([]);
    //const [voidQuestionsBlank, setVoidQuestionsBlank] = useState<VoidQuestions>({
    //    braces: [],
    //    floorEnds: [],
    //    plateEnds: [],
    //    hookEnds: [],
    //    ladders: [],
    //    noLadder: false,
    //    noLadderReason: "",
    //    ladderExtras: [],
    //    accessPanels: [],
    //    noAccessPanels: false,
    //    noAccessPanelsReason: "",
    //    decks700: [],
    //    decks550: [],
    //    decks300: [],
    //    decks150: [],
    //    noDecks: false,
    //    noDecksReason: ""
    //});
    const [scheduleIds, setScheduleIds] = useState<number[]>([]);
    const [swmsOptions, setSwmsOptions] = useState<GenericList[]>([]);
    const [swmsManualItems, setSwmsManualItems] = useState<SwmsItem[]>([]);
    const [saveDisabled, setSaveDisabled] = useState(false);
  

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const apiUrl = "GetDriverJobs";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setTruckOptions(result.data.truckOptions);
            setTruckIndex(result.data.truckIndex);
            setTruckJobList(result.data.truckJobList);
            setScheduleTypes(result.data.scheduleTypes);
            //setTruckNotes(result.data.truckNotes);
            //setVoidQuestionsBlank(result.data.voidQuestions);
            setLoading(false);
        }
    }

    const refreshJobs = () => {
        getData();
    }

    const updateJobs = (updatedJobs: DriverJob[]) => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        if (truckJob) {
            truckJob.jobs = updatedJobs;
            setTruckJobList(truckJobs);
        }
    }

    //const openTomorrowJobs = (e: any) => {
    //    e.preventDefault();

    //    setShowDepartOffice(false);
    //    setShowArriveSite(false);
    //    setShowDepartSite(false);
    //    setShowSkipJob(false);
    //    setShowPartComplete(false);
    //    setShowPartItems(false);
    //    setShowPartQuestions(false);
    //    setShowComplete(false);
    //    setShowCompleteQuestions(false);
    //}

    //const closeTomorrowJobs = () => {
    //    setShowDepartOffice(false);
    //    setShowArriveSite(false);
    //    setShowDepartSite(false);
    //    setShowSkipJob(false);
    //    setShowPartComplete(false);
    //    setShowPartItems(false);
    //    setShowPartQuestions(false);
    //    setShowComplete(false);
    //    setShowCompleteQuestions(false);
    //}

    const showSiteIssues = (truckJobIndex: number) => {
        var truckList = [...truckJobList];
        var jobs = truckList[truckIndex].jobs;
        var job = jobs[truckJobIndex];

        job.showSiteIssues = !job.showSiteIssues;

        setTruckJobList(truckList);
    }

    const getActualTimes = async (truckId: number) => {
        var truckList = [...truckJobList];
        var truckJob = truckJobList[truckIndex];

        const apiUrl = "GetDriverActualTimes?VehicleId=" + truckId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            truckJob.actualSiteTimeFormatted = result.data.actualSiteTimeFormatted;
            truckJob.actualTravelTimeFormatted = result.data.actualTravelTimeFormatted;
            setTruckJobList(truckList);
        };
    }

    //update the truck selected
    const updateTruckIndex = (updatedTruckIndex: number) => {
        setTruckIndex(updatedTruckIndex);
    }

    //depart office
    const departOffice = () => {
        setShowDepartOffice(true);
    }

    const resetDepartureCheck = () => {
        var departureCheck: DepartureCheck = {
            id: 0,
            gearCheck: -1,
            teamMemberPpe: -1
        };

        return departureCheck;
    }

    const updateDepartureCheck = (fieldName: string, fieldValue: number) => {
        setDepartureCheck(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const saveDepartOffice = () => {
        if (saveDisabled) {
            return;
        }
        setSaveDisabled(true);
        departOfficeSave();
    }

    const departOfficeSave = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        var jobs = truckJob.jobs;
        if (jobs.length > 0) {
            //set departure time for all scheduled items for first job
            var job = jobs[0];
            var officeAddrLatLng: GoogleAddressItem = {
                lat: job.officeAddressLatitude,
                lng: job.officeAddressLongitude,
                fullAddress: job.officeAddress
            };
            var siteAddrLatLng: GoogleAddressItem = {
                lat: job.siteAddressLatitude,
                lng: job.siteAddressLongitude,
                fullAddress: job.siteAddress
            };

            var jobScheduleIds: number[] = [];
            for (var i = 0; i < job.items.length; i++) {
                jobScheduleIds.push(job.items[i].id);
            }

            //calculate distance to first job via google
            var duration = 0;
            var resultFirst = await UtilsGoogleMaps.calculateDistance(officeAddrLatLng, siteAddrLatLng);
            if (resultFirst) {
                duration = resultFirst.duration;
            };
            var estTravelTimeMins = Math.round(duration / 60);

            //calcuate estimated travel time route
            var siteAddresses: GoogleAddressItem[] = [];
            for (var j = 0; j < jobs.length; j++) {
                var siteAddrLatLng: GoogleAddressItem = {
                    lat: jobs[j].siteAddressLatitude,
                    lng: jobs[j].siteAddressLongitude,
                    fullAddress: jobs[j].siteAddress
                };
                siteAddresses.push(siteAddrLatLng);
            }
            var totalDuration = 0;
            var resultTotal = await UtilsGoogleMaps.calculateDistanceRoute(officeAddrLatLng, siteAddresses);
            if (resultTotal) {
                totalDuration = resultTotal.duration;
            };

            if (totalDuration === 0) {
                //remove manual jobs and try again
                var siteAddressExclManual: GoogleAddressItem[] = [];
                for (var j = 0; j < jobs.length; j++) {
                    if (!jobs[j].isManualJob) {
                        var siteAddrExManualLatLng: GoogleAddressItem = {
                            lat: jobs[j].siteAddressLatitude,
                            lng: jobs[j].siteAddressLongitude,
                            fullAddress: jobs[j].siteAddress
                        };
                        siteAddressExclManual.push(siteAddrExManualLatLng);
                    }
                }

                totalDuration = 0;
                if (siteAddressExclManual.length > 0) {
                    var resultExclManual = await UtilsGoogleMaps.calculateDistanceRoute(officeAddrLatLng, siteAddressExclManual);
                    if (resultExclManual) {
                        totalDuration = resultExclManual.duration;
                    };
                }
            }
            var estRouteTravelTimeMins = Math.round(totalDuration / 60);

            var departOffice = {
                scheduleIds: jobScheduleIds,
                vehicleId: truckJob.truckId,
                teamMemberPpe: departureCheck.teamMemberPpe,
                estTravelTimeMins: estTravelTimeMins,
                estRouteTravelTimeMins: estRouteTravelTimeMins
            };

            var jsonItem = JSON.stringify(departOffice);

            const apiUrl = "DepartOffice";
            var result = await PostQuery(apiUrl, jsonItem);
            if (result.error) {
                toast.error("Error saving data!");
            } else {
                if (result.data.isError) {
                    var errors = result.data.messages as any[];
                    errors.map(function (error: any) {
                        toast.error(error.content);
                    });
                } else {
                    toast.success("Depart Office has been saved");
                    var departureChecks = resetDepartureCheck();

                    truckJob.hasDepartedOffice = true;
                    truckJob.hasDepartedOffice = result.data.runsheetTime;
                    truckJob.estimatedTravelTimeFormatted = result.data.estTravelTime;

                    setShowDepartOffice(false);
                    setDepartureCheck(departureChecks);
                    setTruckJobList(truckJobs);
                    setSaveDisabled(false);
                }
            };
        }
  
    }

    //Arrive Office
    const arriveOffice = () => {
        arriveOfficeSave();
    }

    const arriveOfficeSave = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];

        var arriveOffice = {
            vehicleId: truckJob.truckId
        };

        var jsonItem = JSON.stringify(arriveOffice);

        const apiUrl = "ArriveOffice";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Arrive Office has been saved");
                truckJob.hasArrivedOffice = true;

                setTruckJobList(truckJobList);
                setSaveDisabled(false);

                //re-calculate the overall actual travel time
                getActualTimes(truckJob.truckId);
            }
        };
    }

    //ARRIVAL
    const startJob = (truckJobIndex: number) => {
        getSwmsOptions(truckJobIndex);
    }

    const getSwmsOptions = async (truckJobIndex: number) => {
        var truckJobs = [...truckJobList];
        var jobs = truckJobs[truckIndex].jobs;
        var job = jobs[truckJobIndex];
        var items = job.items;

        var jobScheduleIds: number[] = [];
        jobScheduleIds.push(job.id);
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
        }

        var getSwms = {
            scheduleIds: jobScheduleIds
        };

        var jsonItem = JSON.stringify(getSwms);

        const apiUrl = "GetSwmsOptions";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            var arrivalCheckReset = resetArrivalCheck();
            setSwmsOptions(result.data);
            setShowArriveSite(true);
            setJobIndex(truckJobIndex);
            setArrivalCheck(arrivalCheckReset)
        };
    }

    const resetArrivalCheck = () => {
        var arrivalCheck: ArrivalCheck = {
            id: 0,
            hazardsRemoved: -1,
            workAreasChecked: -1,
            layoutPlanMaterialsAvailable: -1,
            siteDamage: -1,
            siteDamageNotes: "",
            siteSwmsChecked: -1
        };

        return arrivalCheck;
    }

    const updateManualSwms = (manualSwms: SwmsItem[]) => {
        setSwmsManualItems(manualSwms);
    }

    const backtoJobs = () => {
        var arrivalCheck = resetArrivalCheck();
        setSwmsOptions([]);
        setSwmsManualItems([]);
        setScheduleIds([]);
        setShowArriveSite(false);
        setShowArriveSiteSwms(false);
        setJobIndex(- 1);
        setArrivalCheck(arrivalCheck);
    }

    const updateArrivalCheck = (updatedArrivalCheck: ArrivalCheck) => {
        setArrivalCheck(updatedArrivalCheck);
    }

    //swms
    const gotoSwms = () => {
        var jobs = [...truckJobList[truckIndex].jobs];
        var job = jobs[jobIndex];
        var items = job.items;

        var jobScheduleIds: number[] = [];
        jobScheduleIds.push(job.id);
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
        }

        setScheduleIds(jobScheduleIds);
        setShowArriveSite(false);
        setShowArriveSiteSwms(true);
    }

    const backtoArrivalChecks = () => {
        setShowArriveSite(true);
        setShowArriveSiteSwms(false);
    }

    const updateSwmsChecked = (swmsChecked: number) => {
        setArrivalCheck(prevState => ({ ...prevState, siteSwmsChecked: swmsChecked }));
    }

    const saveArriveSite = () => {
        if (saveDisabled) {
            return;
        }
        setSaveDisabled(true);
        arriveSite();
    }

    const arriveSite = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        var items = job.items;

        var jobScheduleIds: number[] = [];
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
        }
        //get previous job (if there is one) so we can calculate actual travel time
        var prevScheduleId = jobIndex === 0 ? 0 : jobs[jobIndex - 1].id;
        var swmsChecked = arrivalCheck.siteSwmsChecked < 0 ? 0 : arrivalCheck.siteSwmsChecked;  //not all items have swms

        var arriveOnSite = {
            scheduleIds: jobScheduleIds,
            prevScheduleId: prevScheduleId,     //used for calculating actual travel time
            vehicleId: truckJob.truckId,
            jobId: job.jobId,
            siteAddressManual: job.siteAddress,
            hazardsRemoved: arrivalCheck.hazardsRemoved,
            workAreasChecked: arrivalCheck.workAreasChecked,
            layoutPlanMaterialsAvailable: arrivalCheck.layoutPlanMaterialsAvailable,
            siteDamage: arrivalCheck.siteDamage,
            siteDamageNotes: arrivalCheck.siteDamageNotes,
            siteSwmsChecked: swmsChecked,
            swmsManualItems: swmsManualItems
        };

        var jsonItem = JSON.stringify(arriveOnSite);

        const apiUrl = "ArriveSite";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Arrival has been saved");
                //update job to arrived
                job.hasArrived = true;

                var resetArrival = resetArrivalCheck();

                setSwmsOptions([]);
                setSwmsManualItems([]);
                setShowArriveSite(false);
                setShowArriveSiteSwms(false);
                setScheduleIds([]);
                setTruckJobList(truckJobs);
                setJobIndex(-1);
                setArrivalCheck(resetArrival);
                setSaveDisabled(false);

                //re-calculate the overall actual travel time
                getActualTimes(truckJob.truckId);
            }
        };
    }

    //DEPART SITE
    const departSite = (truckJobIndex: number) => {
        var truckJob = truckJobList[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[truckJobIndex];
        //var isVoid = job.items.filter(i => i.isVoid).length > 0;

        setShowDepartSite(true);
        setJobIndex(truckJobIndex);
        setIsAssistJob(job.isAssistJob);
        //setIsVoidJob(isVoid);
        setIsManualJob(job.isManualJob);
    }

    const cancelDepartSite = () => {
        setShowDepartSite(false);
        setJobIndex(-1);
        setIsAssistJob(false);
        //setIsVoidJob(false);
        setIsManualJob(false);
    }

    //Skip Job
    const skipJob = () => {
        setShowDepartSite(false);
        setShowSkipJob(true);
        setShowPartComplete(false);
        setShowPartQuestions(false);
        setShowComplete(false);
        setShowCompleteQuestions(false);
    }

    const skipJobBack = () => {
        setShowDepartSite(true);
        setShowSkipJob(false);
        setShowPartComplete(false);
        setShowPartQuestions(false);
        setShowComplete(false);
        setShowCompleteQuestions(false);
    }

    const updateSkipJobNotes = (notes: string) => {
        setSkipJobNotes(notes);
    }

    const saveSkipJob = () => {
        if (saveDisabled) {
            return;
        }
        setSaveDisabled(true);
        skipJobSave();
    }

    const skipJobSave = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        var items = job.items;

        var siteAddrLatLng: GoogleAddressItem = {
            lat: job.siteAddressLatitude,
            lng: job.siteAddressLongitude,
            fullAddress: job.siteAddress
        };

        var jobScheduleIds: number[] = [];
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
        }

        //check if there is another job after this one as need to update departure time
        var duration = 0;
        var nextscheduleIds: number[] = [];
        var nextIndex = jobIndex + 1;
        if (nextIndex < jobs.length) {
            var nextJob = jobs[nextIndex];
            if (nextJob) {
                var nextJobItems = nextJob.items;
                for (var i = 0; i < nextJobItems.length; i++) {
                    nextscheduleIds.push(nextJobItems[i].id);
                }

                var nextJobAddrLatLng: GoogleAddressItem = {
                    lat: nextJob.siteAddressLatitude,
                    lng: nextJob.siteAddressLongitude,
                    fullAddress: nextJob.siteAddress
                };

                //calculate distance to job via google
                var resultNextJob = await UtilsGoogleMaps.calculateDistance(siteAddrLatLng, nextJobAddrLatLng);
                if (resultNextJob) {
                    duration = resultNextJob.duration;
                };
            }
        }

        var estTravelTimeMins = Math.round(duration / 60);
        var truck = getTruckName(truckJob.truckId);

        var skipJob = {
            scheduleIds: jobScheduleIds,
            nextScheduleIds: nextscheduleIds,
            notes: skipJobNotes,
            siteAddress: job.siteAddress,
            truck: truck,
            estTravelTimeMins: estTravelTimeMins,
            jobId: job.jobId
        };

        var jsonItem = JSON.stringify(skipJob);

        const apiUrl = "SkipJob";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Job has been saved");
                //update job to arrived
                job.isComplete = true;
                var allJobsComplete = false;
                if (nextscheduleIds.length === 0) {
                    allJobsComplete = true;
                }
                truckJob.allJobsComplete = allJobsComplete;

                setTruckJobList(truckJobs);
                setShowSkipJob(false);
                setShowPartComplete(false);
                setShowPartQuestions(false);
                setShowComplete(false);
                setShowCompleteQuestions(false);
                setJobIndex(-1);
                setSkipJobNotes("");
                setSaveDisabled(false);
                setIsAssistJob(false);
                //setIsVoidJob(false);
                setIsManualJob(false);

                //re-calculate the overall actual site time
                getActualTimes(truckJob.truckId);
            }
        };
    }

    const getTruckName = (truckId: number) => {
        var truck = "";
        var truckOption = truckOptions.find(t => t.id === truckId);
        if (truckOption) {
            truck = truckOption.name;
        }
        return truck;
    }

    //Part Complete Job
    const partCompleteCurrentJob = () => {
        var partCompleteReset = resetPartComplete();
        var completeQuestions = resetCompletionCheck();

        var truckJob = truckJobList[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        partCompleteReset.jobItems = job.items;

        setShowDepartSite(false);
        setShowPartComplete(true);
        setShowPartQuestions(false);
        setShowComplete(false);
        setShowCompleteQuestions(false);
        setPartCompleteJob(partCompleteReset);
        setCompletionCheck(completeQuestions);
        setJobType(job.jobType);
        setIsKwikstage(job.isKwikstage);
        setTeam(job.team);
    }

    const partCompleteJobBack = () => {
        var partCompleteJob = resetPartComplete();
        var completeQuestons = resetCompletionCheck();
        setShowDepartSite(true);
        setShowPartComplete(false);
        setShowPartQuestions(false);
        setShowComplete(false);
        setShowCompleteQuestions(false);
        setPartCompleteJob(partCompleteJob);
        setCompletionCheck(completeQuestons);
        setJobType(0);
        setIsKwikstage(false);
        setTeam([]);
    }

    const resetPartComplete = () => {
        var partCompleteJob: PartCompleteJob = {
            planChanges: {
                planChanges: -1,
                plan: new File([""], "filename"),
                planComments: "",
                notes: ""
            },
            jobItems: [],
            notes: ""
        };

        return partCompleteJob;
    }

    const updatePartCompletePlanChangesNumber = (fieldName: string, fieldValue: number) => {
        setPartCompleteJob(prevState => ({ ...prevState, planChanges: { ...prevState.planChanges, [fieldName]: fieldValue } }));
    }

    const updatePartCompletePlanChangesText = (fieldName: string, fieldValue: string) => {
        setPartCompleteJob(prevState => ({ ...prevState, planChanges: { ...prevState.planChanges, [fieldName]: fieldValue } }));
    }

    const updatePartCompletePlan = (planFile: File) => {
        setPartCompleteJob(prevState => ({ ...prevState, planChanges: { ...prevState.planChanges, plan: planFile } }));
    }

    const updatePartCompleteNotes = (updatedNotes: string) => {
        setPartCompleteJob(prevState => ({ ...prevState, notes: updatedNotes }));
    }

    const updatePartCompleteItemNumber = (itemIndex: number, fieldName: string, fieldValue: number) => {
        setPartCompleteJob(prevState => ({
            ...prevState,
            jobItems: prevState.jobItems.map((item, index) =>
                index === itemIndex ? { ...item, [fieldName]: fieldValue } : item
            )
        }));
    }

    const updatePartCompleteItemBool = (itemIndex: number, fieldName: string, fieldValue: boolean) => {
        setPartCompleteJob(prevState => ({
            ...prevState,
            jobItems: prevState.jobItems.map((item, index) =>
                index == itemIndex ? { ...item, [fieldName]: fieldValue } : item
            )
        }));
    }

    const updateItemPart = (itemIndex: number, partIndex: number, updatedItemPart: ItemPart) => {
        setPartCompleteJob(prevState => ({
            ...prevState,
            jobItems: prevState.jobItems.map((item, index) =>
                index == itemIndex ? {
                    ...item,
                    itemParts: item.itemParts.map((itemPart, index) =>
                        index == partIndex ? { ...itemPart, updatedItemPart } : itemPart
                    )
                } : item
            )
        }));
    }

    const goToPartItems = () => {
        setShowPartComplete(false);
        setShowPartItems(true);
    }

    const partItemsBack = () => {
        setShowPartComplete(true);
        setShowPartItems(false);
    }

    const gotoPartQuestions = () => {
        setShowPartItems(false);
        setShowPartQuestions(true);
    }

    const partQuestionsBack = () => {
        setShowPartItems(true);
        setShowPartQuestions(false);
    }

    const updatePartQuestionsNumber = (fieldName: string, fieldValue: number) => {
        setCompletionCheck(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const updatePartQuestionsText = (fieldName: string, fieldValue: string) => {
        setCompletionCheck(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const savePartComplete = () => {
        if (saveDisabled) {
            return;
        }
        setSaveDisabled(true);
        partCompleteSave();
    }

    const partCompleteSave = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        
        //get jobs from the part complete job
        var items = partCompleteJob.jobItems;

        var siteAddrLatLng: GoogleAddressItem = {
            lat: job.siteAddressLatitude,
            lng: job.siteAddressLongitude,
            fullAddress: job.siteAddress
        };

        var jobItems = [];
        var jobScheduleIds: number[] = [];
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
            let jobItem = {
                scheduleId: items[i].id,
                kwikstageId: items[i].kwikstageId,
                complete: items[i].isComplete,
                percentComplete: items[i].percentComplete,
                estimatedTimeMins: items[i].estimatedTimeMins,
                itemParts: items[i].itemParts,
                other: items[i].other
            };
            jobItems.push(jobItem);
        }

        //check if there is another job after this one as need to update departure time
        var duration = 0;
        var nextscheduleIds: number[] = [];
        var nextIndex = jobIndex + 1;
        if (nextIndex < jobs.length) {
            var nextJob = jobs[nextIndex];
            if (nextJob) {
                var nextJobItems = nextJob.items;
                for (var i = 0; i < nextJobItems.length; i++) {
                    nextscheduleIds.push(nextJobItems[i].id);
                }

                var nextJobAddrLatLng: GoogleAddressItem = {
                    lat: nextJob.siteAddressLatitude,
                    lng: nextJob.siteAddressLongitude,
                    fullAddress: nextJob.siteAddress
                };

                //calculate distance to job via google
                var resultNextJob = await UtilsGoogleMaps.calculateDistance(siteAddrLatLng, nextJobAddrLatLng);
                if (resultNextJob) {
                    duration = resultNextJob.duration;
                };
            }
        }
        var estTravelTimeMins = Math.round(duration / 60);
        var truck = getTruckName(truckJob.truckId);
        var planChanges = partCompleteJob.planChanges.planChanges * 1;

        var partCompletedSite = {
            scheduleIds: jobScheduleIds,
            nextScheduleIds: nextscheduleIds,
            estTravelTimeMins: estTravelTimeMins,
            vehicleId: job.truckId,
            jobId: job.jobId,
            siteAddressManual: job.siteAddress,
            siteAddress: job.siteAddress,
            truck: truck,
            jobItems: jobItems,
            completionCheck: completionCheck,
            notes: partCompleteJob.notes,
            planChanges: planChanges === 1,
            planComments: partCompleteJob.planChanges.planComments,
            planNotes: partCompleteJob.planChanges.notes
        };

        var plan = partCompleteJob.planChanges.plan;
        var partComplete = resetPartComplete();
        var completion = resetCompletionCheck();

        var jsonItem = JSON.stringify(partCompletedSite);

        const apiUrl = "PartCompleteJob";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                if (plan.size > 0) {
                    savePlanChanges(plan, jobScheduleIds, nextscheduleIds, job, truckJobs, truckJob, partComplete, completion);
                } else {
                    toast.success("Job has been saved");
                    //update job to complete
                    job.isComplete = true;
                    var allJobsComplete = false;
                    if (nextscheduleIds.length === 0) {
                        allJobsComplete = true;
                    }
                    truckJob.allJobsComplete = allJobsComplete;

                    setTruckJobList(truckJobs);
                    setShowDepartSite(false);
                    setShowPartComplete(false);
                    setShowPartQuestions(false);
                    setShowComplete(false);
                    setShowCompleteQuestions(false);
                    setPartCompleteJob(partComplete);
                    setCompletionCheck(completion);
                    setJobType(0);
                    setIsKwikstage(false);
                    setTeam([]);
                    setSaveDisabled(false);
                    setIsAssistJob(false);
                    //setIsVoidJob(false);
                    setIsManualJob(false);

                    //re-calculate the overall actual site time
                    getActualTimes(truckJob.truckId);
                }
            }
        };
    }

    //Void Questions - can be called from Part Complete or Complete
    const goToVoidQuestions = () => {
        //get the questions for this job.
        var truckJob = truckJobList[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        var voidJobGearList = job.voidGearList;

        var jobScheduleIds: number[] = [];
        for (var i = 0; i < job.items.length; i++) {
            jobScheduleIds.push(job.items[i].id);
        }

        setShowComplete(false);
        //setShowVoidQuestions(true);
        setScheduleIds(jobScheduleIds);
        setVoidGearList(voidJobGearList);
    }

    //const updateVoidGearList = (updatedVoidGearList: VoidQuestions, updatedVoidDescription: string, itemIndex: number) => {
    //    setVoidGearList(prevState => prevState.map((item, index) =>
    //        index == itemIndex ? { ...item, gearList: updatedVoidGearList, voidDescription: updatedVoidDescription } : item
    //    ));
    //}

    //const resetVoidQuestions = () => {
    //    var newVoidQuestions: VoidQuestions = {
    //        braces: { ...voidQuestionsBlank.braces },
    //        floorEnds: { ...voidQuestionsBlank.floorEnds },
    //        plateEnds: { ...voidQuestionsBlank.plateEnds },
    //        hookEnds: { ...voidQuestionsBlank.hookEnds },
    //        ladders: { ...voidQuestionsBlank.ladders },
    //        noLadder: false,
    //        noLadderReason: "",
    //        ladderExtras: { ...voidQuestionsBlank.ladderExtras },
    //        accessPanels: { ...voidQuestionsBlank.accessPanels },
    //        noAccessPanels: false,
    //        noAccessPanelsReason: "",
    //        decks700: { ...voidQuestionsBlank.decks700 },
    //        decks550: { ...voidQuestionsBlank.decks550 },
    //        decks300: { ...voidQuestionsBlank.decks300 },
    //        decks150: { ...voidQuestionsBlank.decks150 },
    //        noDecks: false,
    //        noDecksReason: ""
    //    };

    //    return newVoidQuestions;
    //}

    //Complete Job
    const completeCurrentJob = () => {
        var completeJob = resetCompleteJob();
        var completion = resetCompletionCheck();

        var truckJob = truckJobList[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        var pickupJobs = job.items.filter(i => i.typeId === 2).length;
        var isPickup = false;
        if (job.items.length === pickupJobs) {
            isPickup = true;
        }
        //skip plan changes page if only pickups
        let showCompl = isPickup ? false : true;
        let showComplQuestions = isPickup ? true : false;

        setShowDepartSite(false);
        setShowPartComplete(false);
        setShowPartQuestions(false);
        setShowComplete(showCompl);
        setShowCompleteQuestions(showComplQuestions);
        setCompleteJob(completeJob);
        setCompletionCheck(completion);
        setJobType(job.jobType);
        setIsKwikstage(job.isKwikstage);
        setTeam(job.team);
        setIsPickup(isPickup);
    }

    const resetCompleteJob = () => {
        var completeJob: PlanChanges = {
            planChanges: -1,
            plan: new File([], ""),
            planComments: "",
            notes: ""
        };

        return completeJob;
    }

    const completeJobBack = () => {
        setShowDepartSite(true);
        setShowComplete(false);
        setShowCompleteQuestions(false);
        setIsPickup(false);
    }

    const updateCompleteNumber = (fieldName: string, fieldValue: number) => {
        setCompleteJob(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const updateCompleteText = (fieldName: string, fieldValue: string) => {
        setCompleteJob(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const updateCompletePlan = (planFile: File) => {
        setCompleteJob(prevState => ({ ...prevState, plan: planFile }));
    }

    const gotoCompleteQuestions = () => { 
        setShowComplete(false);
        //setShowVoidQuestions(false);
        setShowCompleteQuestions(true);
    }

    const resetCompletionCheck = () => {
        var compCheck: CompletionCheck = {
            swmsSiteContact: -1,
            scaffoldSquare: -1,
            scaffoldGaps: -1,
            accessPointsInstalled: -1,
            scaffoldSupported: -1,
            safetySigns: -1,
            handrailsChecked: -1,
            gapsChecked: -1,
            fittingsSecure: -1,
            siteChecked: -1,
            rubbishInBin: -1,
            siteSecured: -1,
            scaffoldSafeCondition: -1,
            scaffoldDamage: -1,
            missingEquipment: -1,
            scaffoldCertificateSigned: -1,
            scaffoldTicketPhoto: -1,
            scaffoldPhotosComplete: -1,
            scaffoldTicketSignedById: -1,
            notes: ""
        };

        return compCheck;
    }

    //const completeVoidQuestionsJobBack = () => {
    //    setShowDepartSite(false);
    //    setShowComplete(true);
    //    setShowVoidQuestions(false);
    //    setShowCompleteQuestions(false);

    //    if (isPickup) {
    //        //can't have plan changes for pickups so skip completion screen
    //        completeJobBack();
    //    }
    //}

    const completeQuestionsJobBack = () => {
        //if (isVoidJob) {
        //    //need to go back to void questions
        //    setShowDepartSite(false);
        //    setShowComplete(true);
        //    setShowVoidQuestions(true);
        //    setShowCompleteQuestions(false);
        //} else {
            setShowDepartSite(false);
            setShowComplete(true);
            setShowCompleteQuestions(false);
            if (isPickup) {
                //can't have plan changes for pickups so skip completion screen
                completeJobBack();
            }
        //}
    }

    const updateCompleteQuestionsNumber = (fieldName: string, fieldValue: number) => {
        setCompletionCheck(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const updateCompleteQuestionsText = (fieldName: string, fieldValue: string) => {
        setCompletionCheck(prevState => ({ ...prevState, [fieldName]: fieldValue }));
    }

    const saveCompleteSite = () => {
        if (saveDisabled) {
            return;
        }
        setSaveDisabled(true);
        completeSiteSave();
    }

    const completeSiteSave = async () => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobs[truckIndex];
        var jobs = truckJob.jobs;
        var job = jobs[jobIndex];
        var items = job.items;

        var siteAddrLatLng: GoogleAddressItem = {
            lat: job.siteAddressLatitude,
            lng: job.siteAddressLongitude,
            fullAddress: job.siteAddress
        };

        var jobScheduleIds: number[] = [];
        var voidScheduleIds: number[] = [];     //need to save gear list for void items
        for (var i = 0; i < items.length; i++) {
            jobScheduleIds.push(items[i].id);
            if (items[i].isVoid) {
                voidScheduleIds.push(items[i].id);
            }
        }

        //check if there is another job after this one as need to update departure time
        var duration = 0;
        var nextscheduleIds: number[] = [];
        var nextIndex = jobIndex + 1;
        if (nextIndex < jobs.length) {
            var nextJob = jobs[nextIndex];
            if (nextJob) {
                var nextJobItems = nextJob.items;
                for (var i = 0; i < nextJobItems.length; i++) {
                    nextscheduleIds.push(nextJobItems[i].id);
                }

                var nextJobAddrLatLng: GoogleAddressItem = {
                    lat: nextJob.siteAddressLatitude,
                    lng: nextJob.siteAddressLongitude,
                    fullAddress: nextJob.siteAddress
                };

                //calculate distance to job via google
                var resultNextJob = await UtilsGoogleMaps.calculateDistance(siteAddrLatLng, nextJobAddrLatLng);
                if (resultNextJob) {
                    duration = resultNextJob.duration;
                };
            } 
        }
        var estTravelTimeMins = Math.round(duration / 60);

        var planChanges = completeJob.planChanges * 1;
        var truck = getTruckName(truckJob.truckId);
        var completedSite = {
            scheduleIds: jobScheduleIds,
            voidScheduleIds: voidScheduleIds,
            nextScheduleIds: nextscheduleIds,
            estTravelTimeMins: estTravelTimeMins,
            vehicleId: job.truckId,
            jobId: job.jobId,
            siteAddressManual: job.siteAddress,
            siteAddress: job.siteAddress,
            truck: truck,
            completionCheck: completionCheck,
            planChanges: planChanges === 1,
            planComments: completeJob.planComments,
            voidGearList: voidGearList,
            notes: completeJob.notes
        };

        var partComplete = resetPartComplete();
        var completion = resetCompletionCheck();

        var plan = completeJob.plan;

        var jsonItem = JSON.stringify(completedSite);

        const apiUrl = "CompleteSite";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                if (plan.size > 0) {
                    savePlanChanges(plan, jobScheduleIds, nextscheduleIds, job, truckJobs, truckJob, partComplete, completion);
                } else {
                    toast.success("Job has been saved.");
                    //update job to complete
                    job.isComplete = true;
                    var allJobsComplete = false;
                    if (nextscheduleIds.length === 0) {
                        allJobsComplete = true;
                    }
                    truckJob.allJobsComplete = allJobsComplete;

                    setTruckJobList(truckJobs);
                    setShowDepartSite(false);
                    setShowPartComplete(false);
                    setShowPartQuestions(false);
                    setShowComplete(false);
                    setShowCompleteQuestions(false);
                    setCompletionCheck(completion);
                    setJobType(0);
                    setIsKwikstage(false);
                    setTeam([]);
                    setVoidGearList([]);
                    setSaveDisabled(false);
                    setIsAssistJob(false);
                    //setIsVoidJob(false);
                    setIsManualJob(false);

                    //re-calculate the overall actual site time
                    getActualTimes(truckJob.truckId);
                }
            }
        };
    }

    const savePlanChanges = async (plan: File, jobScheduleIds: number[], nextscheduleIds: number[], job: DriverJob, truckJobs: TruckJobList[], truckJob: TruckJobList, partComplete: PartCompleteJob, completion: CompletionCheck) => {
        //upload the file
        const filedata = new FormData()
        filedata.append('ScheduleId', jobScheduleIds[0].toString());
        filedata.append('TypeId', "1");
        filedata.append('photo', plan);

        const apiUrl = "SaveSchedulePhoto";
        var result = await PostFormDataQuery(apiUrl, filedata);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Job has been saved.");
                //update job to complete
                job.isComplete = true;
                var allJobsComplete = false;
                if (nextscheduleIds.length === 0) {
                    allJobsComplete = true;
                }
                truckJob.allJobsComplete = allJobsComplete;

                setTruckJobList(truckJobs);
                setShowDepartSite(false);
                setShowPartComplete(false);
                setShowPartQuestions(false);
                setShowComplete(false);
                setShowCompleteQuestions(false);
                setPartCompleteJob(partComplete);
                setCompletionCheck(completion);
                setJobType(0);
                setIsKwikstage(false);
                setTeam([]);
                setVoidGearList([]);
                setSaveDisabled(false);
                setIsAssistJob(false);
                //setIsVoidJob(false);
                setIsManualJob(false);

                //re-calculate the overall actual site time
                getActualTimes(truckJob.truckId);
            }
        };
    }

    //complete tool check from last job
    const goToolCheck = () => {
        var truckJob = truckJobList[truckIndex];

        navigate("/drivertoolcheck/" + truckJob.truckId + "/2");
    }

    //Lunch Break
    const saveLunch = (scheduleId: number, jobId: number) => {
        saveLunchBreak(scheduleId, jobId);
    }

    const saveLunchBreak = async (scheduleId: number, jobId: number) => {
        var truckJobs = [...truckJobList];
        var truckJob = truckJobList[truckIndex];

        var lunchBreak = {
            truckId: truckJob.truckId,
            scheduleId: scheduleId,
            jobId: jobId
        };

        var jsonItem = JSON.stringify(lunchBreak);

        const apiUrl = "SaveLunchBreak";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Lunch Break has been saved.");
                truckJob.hadLunch = true;

                setTruckJobList(truckJobs);
                setSaveDisabled(false);
            }
        };
    }

    var truckId = truckJobList.length > 0 && truckIndex >= 0 ? truckJobList[truckIndex].truckId : -1;
    var driverTabsMobile = <DriverTabData tab="driverjobs" truckId={truckId} />
    var innercontents;

    const renderDetails = () => {
        if (showDepartOffice) {
            innercontents = <DriverJobsDepartOfficeData truckId={truckId} departureCheck={departureCheck} saveDisabled={saveDisabled} updateDetails={updateDepartureCheck} save={saveDepartOffice} />
        } else if (showArriveSite) {
            innercontents = <DriverJobsSiteArrivalData truckId={truckId} arrivalCheck={arrivalCheck} back={backtoJobs} updateDetails={updateArrivalCheck} save={gotoSwms} />
        } else if (showArriveSiteSwms) {
            innercontents = <DriverJobsSiteArrivalSwmsData scheduleIds={scheduleIds} swmsOptions={swmsOptions} swmsManualItems={swmsManualItems} swmsChecked={arrivalCheck.siteSwmsChecked} vehicleId={truckId} saveDisabled={saveDisabled} back={backtoArrivalChecks} update={updateSwmsChecked} updateManualSwms={updateManualSwms} save={saveArriveSite} />
        } else if (showDepartSite) {
            innercontents = <DriverJobsSiteDepartureData isAssistJob={isAssistJob} isManualJob={isManualJob} cancel={cancelDepartSite} skipJob={skipJob} partCompleteJob={partCompleteCurrentJob} completeJob={completeCurrentJob} />
        } else if (showSkipJob) {
            innercontents = <DriverJobsSiteDepartureSkipData saveDisabled={saveDisabled} back={skipJobBack} notes={skipJobNotes} update={updateSkipJobNotes} save={saveSkipJob} />
        } else if (showPartComplete) {
            innercontents = <DriverJobsSiteDeparturePartData back={partCompleteJobBack} partCompleteJob={partCompleteJob} updatePlanChangesNumber={updatePartCompletePlanChangesNumber} updatePlanChangesText={updatePartCompletePlanChangesText} updatePlan={updatePartCompletePlan} next={goToPartItems} />
        } else if (showPartItems) {
            innercontents = <DriverJobsSiteDeparturePartItemsData back={partItemsBack} partCompleteJob={partCompleteJob} updateNotes={updatePartCompleteNotes} updateItemNumber={updatePartCompleteItemNumber} updateItemBool={updatePartCompleteItemBool} updateItemPart={updateItemPart} next={gotoPartQuestions} />
        } else if (showPartQuestions) {
            innercontents = <DriverJobsSiteDeparturePartQuestionsData saveDisabled={saveDisabled} back={partQuestionsBack} team={team} completionCheck={completionCheck} jobType={jobType} isKwikstage={isKwikstage} updatePartCompleteQuestionsNumber={updatePartQuestionsNumber} updatePartCompleteQuestionsText={updatePartQuestionsText} save={savePartComplete} />
        } else if (showComplete) {
            innercontents = <DriverJobsSiteDepartureCompleteData back={completeJobBack} completeJob={completeJob} isPickup={isPickup} updatePlanChangesNumber={updateCompleteNumber} updatePlanChangesText={updateCompleteText} updatePlan={updateCompletePlan} next={gotoCompleteQuestions} />
            //    innercontents = <DriverJobsSiteDepartureCompleteData back={this.completeJobBack} completeJob={completeJob} isPickup={isPickup} update={this.updateComplete} next={isVoidJob ? this.goToVoidQuestions : this.gotoCompleteQuestions} />
            //} else if (showVoidQuestions) {
            //    innercontents = <DriverJobsSiteDepartureVoidQuestionsData back={this.completeVoidQuestionsJobBack} fromCompleteJob={true} scheduleIds={scheduleIds} voidGearList={voidGearList} update={this.updateVoidGearList} next={this.gotoCompleteQuestions } />
        } else if (showCompleteQuestions) {
            innercontents = <DriverJobsSiteDepartureCompleteQuestionsData saveDisabled={saveDisabled} back={completeQuestionsJobBack} team={team} completionCheck={completionCheck} jobType={jobType} isKwikstage={isKwikstage} updateCompleteQuestionsNumber={updateCompleteQuestionsNumber} updateCompleteQuestionsText={updateCompleteQuestionsText} save={saveCompleteSite} />
        } else {
            innercontents = <DriverJobsListData truckIndex={truckIndex} truckId={truckId} truckOptions={truckOptions} truckJobList={truckJobList} scheduleTypes={scheduleTypes} updateTruckIndex={updateTruckIndex} departOffice={departOffice} arriveOffice={arriveOffice} arriveSite={startJob} departSite={departSite} showSiteIssues={showSiteIssues} goToolCheck={goToolCheck} saveLunch={saveLunch} refreshJobs={refreshJobs} updateJobs={updateJobs} />
        }

        return (
            <div>
                <div>

                </div>
                <div className="mobileFont marginTop10 marginBottom70">
                    {innercontents}
                </div>
                <div className={showArriveSite ? "hidden" : ""}>
                    {driverTabsMobile}
                </div>
            </div>
        );
    }

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails();

    return <div>
        {contents}
    </div>;
    
}

export default DriverJobsData;